import React from 'react';

export default function SmsComponent() {
  return <div style={{ background: 'white', height: '100%' }}>This is SmsComponent</div>;
}
